import { useTranslation } from "react-i18next";
import { CircleHelp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@nexus/ui";

/**
 * Extra guidance for one field, such as an example, behind a focusable help button so the field
 * itself keeps a single short hint. Carries its own provider so it also works outside the app shell.
 */
export function FieldHelp({ label, children }: { label: string; children: string }) {
  const { t } = useTranslation();

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex size-4 shrink-0 items-center justify-center rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/40"
            aria-label={t("iam.onboarding.fieldHelp", { field: label, defaultValue: "More about {{field}}" })}
          >
            <CircleHelp className="size-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[320px] leading-relaxed">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
